import TEXTS from './texts';

export const SECTIONS = {
  HOME: {
    name: 'home',
    title: 'Enrique Mejía',
    hideOnNavbar: true,
  },
  WHAT_DRIVES_ME: {
    name: 'what-drives-me',
    title: TEXTS.WHAT_DRIVES_ME.title
  },
  WHAT_I_DO: {
    name: 'what-i-do',
    title: TEXTS.WHAT_I_DO.title
  },
  HOW_I_WORK: {
    name: 'how-i-work',
    title: TEXTS.HOW_I_WORK.title
  },
  WHO_I_AM: {
    name: 'who-i-am',
    title: TEXTS.WHO_I_AM.title
  },
  CONTACT: {
    name: 'contact',
    title: 'Contact'
  },
}
